// extracted by mini-css-extract-plugin
export default {"container":"MapPage_container__qgmgO","map_container":"MapPage_map_container__ED3vw","cluster":"MapPage_cluster__oqg3u","back_btn":"MapPage_back_btn__XQN5l"};